import React, { useCallback, useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Box, ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { HashRouter } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import TopBar from './features/navigation/components/TopBar';
import SideBar from './features/navigation/components/SideBar';
import Viewer from './features/navigation/components/Viewer';
import { useGetConfigQuery } from './features/purchase-page/services/purchase.endpoints';
import { useAppDispatch, useAppSelector } from './shared/state/hooks';
import { selectIsLoggedIn } from './features/auth/state/userSelectors';
import apiSlice, { tagTypes } from './shared/state/apiSlice';
// import Footer from './features/navigation/components/Footer';
import Footer from './features/navigation/components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#37474F',
    },
    secondary: {
      main: '#90A4AE',
    },
  },
});

export default function App() {
  // await window.electron.writeReceipt(filename, receipt);
  const showActivateCallback = useCallback((data: unknown) => {
    // eslint-disable-next-line no-console
    console.log('activate:show', data);
  }, []);

  useEffect(() => {
    if (window.electron) {
      return window.electron.ipcRenderer.on(
        'activation:show',
        showActivateCallback,
      );
    }
    return undefined;
  }, [showActivateCallback]);

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const { data: config } = useGetConfigQuery();
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  // Invalidate all cached api data after logout occurs
  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(apiSlice.util.invalidateTags(tagTypes));
    }
  }, [dispatch, isLoggedIn]);

  if (!config) return null;
  const { stripeClientToken } = config;
  const stripePromise = loadStripe(stripeClientToken);
  // Define fixed widths for the sidebar in its open and closed states
  const drawerWidthOpen = 240;
  const drawerWidthClosed = 60;

  // Determine the marginLeft based on the open state of the sidebar
  const marginLeft = isSidebarOpen ? drawerWidthOpen : drawerWidthClosed;
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <HashRouter>
          <Elements stripe={stripePromise}>
            <CssBaseline />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
              }}
            >
              <SideBar
                open={isSidebarOpen}
                onToggle={() => setSidebarOpen(!isSidebarOpen)}
              />
              <Box
                sx={{
                  flexGrow: 1,
                  // background: '#fafafb',
                  background: '#F4F5F7',
                  transition: 'margin-left 0.3s ease',
                  marginLeft: `${marginLeft}px`,
                }}
              >
                <TopBar />
                <Viewer />
              </Box>
              <Footer marginLeft={marginLeft} />
            </Box>
          </Elements>
        </HashRouter>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
